import { Injectable } from '@angular/core';
import { Router, NavigationStart } from '@angular/router';
import { Observable, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AlertaService {
  private subject = new Subject<any>();
  private keepAfterNavigationChange = false;

  constructor(private router: Router) {
    // Limpiar el mensaje de alerta cuando se cambia de ruta
    router.events.subscribe(event => {
      if (event instanceof NavigationStart) {
        if (this.keepAfterNavigationChange) {
          // mantener para un solo cambio
          this.keepAfterNavigationChange = false;
        } else {
          // limpiar alerta
          this.subject.next();
        }
      }
    });
  }

  success(mensaje: string, keepAfterNavigationChange = false) {
    this.keepAfterNavigationChange = keepAfterNavigationChange;
    this.subject.next({ type: 'success', text: mensaje });
  }

  error(mensaje: string, keepAfterNavigationChange = false) {
    this.keepAfterNavigationChange = keepAfterNavigationChange;
    this.subject.next({ type: 'error', text: mensaje });
  }

  limpiar() { this.subject.next(); }

  getMessage(): Observable<any> {
    return this.subject.asObservable();
  }
}
